import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import CollectContextProvider from '../collect/CollectContextProvider';
import ErrorBoundary from '../validate/ErrorBoundary';
import WaitWhileBusy from '../WaitWhileBusy';
import SupportIcon from './common/SupportIcon/SupportIcon';
import EventSidePanel from './EventSidePanel';
import './SidePanel.scss';

const SidePanel = (props) => {
    const { containerSelector } = props,
        maximize = useSelector((state) => state.ui.sidePanel.maximize),
        hasSidePanelView = useSelector((state) => !!state.ui.sidePanel.activeViews);

    // Update body classes
    useEffect(() => {
        if (hasSidePanelView) {
            document.body.classList.add('splitsScreenActive');
            if (maximize) {
                document.body.classList.add('minimizeApp');
            } else {
                document.body.classList.remove('minimizeApp');
            }
        } else {
            document.body.classList.remove('splitsScreenActive');
            document.body.classList.remove('minimizeApp');
        }
    }, [maximize, hasSidePanelView]);

    try {
        return createPortal(
            <ErrorBoundary>
                <WaitWhileBusy alt={<span />}>
                    <CollectContextProvider context="networkarea">
                        <Route path="/events/:eventId" component={EventSidePanel} />
                    </CollectContextProvider>
                    <SupportIcon />
                </WaitWhileBusy>
            </ErrorBoundary>,
            document.querySelector(containerSelector)
        );
    } catch (err) {}
    return null;
};

export default SidePanel;
